import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CTABand({
  title = "¿Listo para transformar Compras en una ventaja competitiva?",
  text = "Construyamos juntos una función de Compras más estratégica, eficiente y orientada al valor.",
  cta = "Hablemos",
  image = null,
}) {
  return (
    <section data-testid="cta-band" className="relative bg-oxford overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="Strategic procurement — infraestructura corporativa" className="w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-oxford/85" />
        </div>
      )}
      {!image && <div className="absolute inset-0 diagonal-lines" />}
      <img src="/brand/isotipo-gold.webp" alt="" className="absolute -left-16 -bottom-24 w-80 opacity-[0.06] pointer-events-none" />
      <div className="absolute right-0 top-10 w-[45%] h-px bg-gradient-to-l from-gold/50 to-transparent rotate-[10deg] origin-right pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
        <div className="max-w-3xl">
          <Reveal>
            <span className="block h-px w-16 bg-gold mb-8" />
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">{title}</h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-base leading-relaxed text-steel max-w-xl">{text}</p>
          </Reveal>
          <Reveal delay={0.24}>
            <Link to="/contacto" data-testid="cta-band-button" className="btn-gold mt-10">
              {cta} <ArrowRight className="h-4 w-4" strokeWidth={2} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
